<template>
    <div class="d-flex align-center mx-2">

        <div class="ml-4 flex-grow-1">
            <div class="text-h5 font-weight-light">
                {{team.name}}
            </div>
        </div>

        <div class="of-x-n">
<!--            :return-value.sync="dates"-->
<!--            v-model.lazy="dateMenu"-->
            <app-toolbar-date-selector :range="this.$store.state.ref.dashboard.selectedRange"></app-toolbar-date-selector>
        </div>

        <v-tooltip left v-if="access.setup">
            <template v-slot:activator="{on}">
                <v-btn
                        color="primary"
                        class="mx-2"
                        small
                        icon
                        v-on="on"
                        @click="gotoTeamSettings(team._id)"
                >
                    <v-icon>mdi-cog</v-icon>
                </v-btn>
            </template>
            Settings
        </v-tooltip>

<!--        <v-btn-->
<!--                icon-->
<!--                color="primary"-->
<!--                class="mx-2"-->
<!--                small-->
<!--        >-->
<!--            <v-icon>mdi-microsoft-excel</v-icon>-->
<!--        </v-btn>-->
        <v-btn
                icon
                color="primary"
                class="mx-2"
                small
                @click="$store.state.ref.teamStats.showCardsSelection = true"
        >
            <v-icon>mdi-apps</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {
    addDays,
    endOfDay, endOfMonth,
    endOfWeek,
    format, isMonday,
    isSameDay,
    isSameMonth,
    isSameYear,
    startOfDay, startOfMonth,
    startOfWeek,
    subDays, subMonths, subWeeks
} from "date-fns";
import AppEmployeeAdd from "@/components/Employees/AppEmployeeAdd";
import {mapActions, mapGetters} from "vuex";
import AppToolbarDateSelector from "@/components/Shared/AppToolbarDateSelector.vue";

export default {
    components: {AppToolbarDateSelector},
    props: {
        shown: Boolean,
    },
    data() {
        return {

        }
    },
    methods: {
        ...mapActions(['gotoTeamSettings']),
        setDates({start, end, title}) {
            this.range.title = title
            this.range.start = start;
            this.range.end = end;
            this.dateMenu = false
        }
    },
    computed: {
        ...mapGetters(['teamsRef', 'devicesByEmployee', "teamsRef", 'access']),

        employees() {
            return this.teamsRef[this.team.teamId]
        },

        devices() {
            // console.log()
            return this.teamsRef[this.$store.state.ref.teamStats.selectedTeam];
        },

        team() {
            // console.log()
            return this.teamsRef[this.$store.state.ref.teamStats.selectedTeam];
        },
    },
}
</script>

<style scoped>

</style>